/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2xpYnJhcnkvY29tcG9uZW50cy9jb21wb25lbnRzL2ZpbHRlcnMvZGF0ZS1maWx0ZXIvcmFuZ2UtZGF0ZS1maWx0ZXIvcmFuZ2UtZGF0ZS1maWx0ZXIuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
